export default __webpack_public_path__ + "static/media/GUIDELOCAL.a5d21219.png";